// extracted by mini-css-extract-plugin
module.exports = {"root":"_0f20b46","image":"_e5b9733","text":"_44f6e32"};